import { render, staticRenderFns } from "./inputPhone.vue?vue&type=template&id=008d35ea&scoped=true&"
import script from "./inputPhone.vue?vue&type=script&lang=js&"
export * from "./inputPhone.vue?vue&type=script&lang=js&"
import style0 from "./inputPhone.vue?vue&type=style&index=0&id=008d35ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d35ea",
  null
  
)

export default component.exports